import type { BoxProps } from '@capturi/ui-components'
import { Box } from '@capturi/ui-components'
import { forwardRef, useContext } from 'react'

import type { NamedCuiComponent } from '../cui'
import ListContext from './ListContext'

export type ListItemSecondaryActionProps = {
  showSecondaryAction?: boolean
} & Omit<BoxProps, 'icon'>

export const ListItemSecondaryAction = forwardRef<
  HTMLDivElement,
  ListItemSecondaryActionProps
>(({ showSecondaryAction: _, ...props }, ref) => {
  const { disableGutters, dense } = useContext(ListContext)
  return (
    <Box
      ref={ref}
      position="absolute"
      top="50%"
      transform="translateY(-50%)"
      right={disableGutters ? 0 : dense ? 2 : 4}
      {...props}
    />
  )
}) as NamedCuiComponent

ListItemSecondaryAction.cuiName = 'ListItemSecondaryAction'
